"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/SecureText/MoreInfoToggle.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _secureText = require('shared/constants/secureText');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _Tooltip = require('web/components/Tooltip');
var _SecureTextExplainer = require('./SecureTextExplainer'); var _SecureTextExplainer2 = _interopRequireDefault(_SecureTextExplainer);

const INFO_ICON_SRC = '/assets/icons/secure-text/info.svg'
const ALERT_ICON_SRC = '/assets/icons/alert-orange.svg'







// ClickTooltip clicks its child element through a native listener, so Enter
// and Space forward to a click.
const clickOnEnterOrSpace = (e) => {
  if (e.key !== 'Enter' && e.key !== ' ') return
  e.preventDefault()
  e.currentTarget.click()
}

const explainer = (
  _react2.default.createElement(_Tooltip.TooltipContent, { className: "secure-text--explainer-content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}}
    , _react2.default.createElement(_SecureTextExplainer2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 27}} )
  )
)

// "More information" link that opens the secure vs. insecure explainer.
// It is a span, not a button: section titles sit inside a <label>, and a
// button there would become the label's control. The same element stays
// mounted across both looks, because ClickTooltip binds its listener to the
// element present at mount.
const MoreInfoToggle = ({ isAlert = false, className }) => (
  _react2.default.createElement(_Tooltip.ClickTooltip, {
    type: "light",
    place: "bottom-left",
    // The explainer is tall and often shifts to fit the viewport, which would
    // leave an arrow pointing at the wrong thing.
    hideArrow: true,
    className: _classBuilder2.default.call(void 0, "secure-text--more-info-wrapper", className),
    content: explainer, __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}

    , _react2.default.createElement('span', {
      role: "button",
      tabIndex: 0,
      onKeyDown: clickOnEnterOrSpace,
      className: _classBuilder2.default.call(void 0, 
        "secure-text--more-info",
        isAlert && "secure-text--more-info--alert",
      ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}

      , _react2.default.createElement('img', {
        className: "secure-text--more-info--icon",
        src: isAlert ? ALERT_ICON_SRC : INFO_ICON_SRC,
        alt: isAlert ? 'Alert' : '', __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}
      )
      ,  _secureText.MORE_INFORMATION_LABEL 
    )
  )
)

exports. default = MoreInfoToggle
